import React from 'react';
import PropTypes from 'prop-types';
import VirtualList from 'react-tiny-virtual-list';
import LinkRowItem from './LinkRowItem';
import css from './LinkList.css';

const LinkList = ({
    links = [],
    onEditClick = () => {},
    onViewClick = () => {},
    onDuplicateClicked = () => {},
    onArchiveClicked = () => {},
    onDeleteLinkClicked = () => {},
}) => {
    const itemSize = 40;
    const space = 2;

    const visibleItems = Math.min(links.length, 8);
    const spaces = links.length ? (visibleItems - 1) * space : 0;
    const height = links.length ? visibleItems * itemSize + spaces : 0;

    return (
        <div className={css.container}>
            <VirtualList
                width="100%"
                height={height}
                itemCount={links.length || 1}
                itemSize={index => {
                    let ret = itemSize;
                    if (index > 0) {
                        ret += space;
                    }
                    return ret;
                }}
                renderItem={({ index, style }) => {
                    const link = links[index];
                    return (
                        <div className={css.row} key={`${link.tag_id}_${link.platform}`} style={style}>
                            <LinkRowItem
                                {...link}
                                linksCount={links.length}
                                onEditClick={onEditClick}
                                onViewClick={onViewClick}
                                onDuplicateClicked={onDuplicateClicked}
                                onArchiveClicked={onArchiveClicked}
                                onDeleteLinkClicked={onDeleteLinkClicked}
                            />
                        </div>
                    );
                }}
            />
        </div>
    );
};

LinkList.propTypes = {
    links: PropTypes.arrayOf(PropTypes.any),
    onEditClick: PropTypes.func,
    onViewClick: PropTypes.func,
    onDuplicateClicked: PropTypes.func,
    onArchiveClicked: PropTypes.func,
    onDeleteLinkClicked: PropTypes.func,
};

export default LinkList;
